import { render, staticRenderFns } from "./Closing.vue?vue&type=template&id=ae7d0e68&"
import script from "./Closing.vue?vue&type=script&lang=ts&"
export * from "./Closing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports